<template>
  <div class="personal">
    <div class="slide">
      <mySlide />
    </div>
    <div class="w1500">
      <div class="personal-content flex">
        <div class="personal-info flex-0">
          <div class="seting-box flex flex-ac" @click="handleChangeSetting">
            <template v-if="setting =='info'">
              <i class="iconfont icon-sz icon-setting"></i>
              <span>设置</span>
            </template>
            <template v-else>
              <i class="iconfont icon-back icon-setting"></i>
              <span>返回</span>
            </template>
          </div>
          <div v-show="setting =='info'">
            <div class="info">
              <div class="info-top">
                <div class="tou-img">
                  <el-avatar :src="$store.state.img" class="avatar-img"></el-avatar>
                </div>
                <div class="flex-1">
                  <div class="edit" @click="$store.commit('setPersonalOpen', 'name')">
                    <span>{{ $store.state.name || '未设置' }}</span>
                    <span class="e">（修改）</span>
                  </div>
                  <div class="level flex flex-ac">
                    <div class="level-item level-money flex flex-ac">
                      <img src="@/assets/images/money.png" class="money-img" />
                      <strong>{{ Number($store.state.money).toFixed(2) }}</strong>
                    </div>
                    <div class="level-item level-masonry flex flex-ac">
                      <img src="@/assets/images/masonry.png" class="masonry-img" />
                      <strong>{{ $store.state.masonry }}</strong>
                    </div>
                  </div>
                </div>
              </div>
              <div class="progress-box">
                <div class="flex flex-ac" style="margin-bottom: 12px;">
                  <div class="level-item flex flex-ac">
                    <span class="span-1">等级：</span>
                    <img v-if="myLevel.img" :src="myLevel.img" class="money-img" />
                    {{ myLevel.title }}
                  </div>
                  <div v-if="myLevel.next.has==1" class="t">
                    {{ myLevel.next.progress }}/{{ myLevel.next.target }}
                    <span class="img-s"> {{ myLevel.next.title }}</span>
                  </div>
                </div>
                <el-progress v-if="myLevel.next.has==1" :percentage="(myLevel.next.progress/myLevel.next.target)*100" :stroke-width="8" :show-text="false"></el-progress>
              </div>
            </div>
            <div class="flex flex-ac">
              <div class="btn-w-r-bg flex-1" style="margin-right: 15px;" @click="goCharge">
                <div class="btn-c-r">立即充值</div>
              </div>
              <div class="btn-w-r-bg flex-1 btn-danger" @click="nextLogin">
                <div class="btn-c-r">退出登录</div>
              </div>
            </div>
          </div>
          <div v-show="setting == 'set'" class="peroson-form">
            <div class="head-img" @click="$refs['excel-upload-input'].click()">
              <el-avatar :src="$store.state.img" :size="100"></el-avatar>
              <div class="icon-edit flex flex-ac flex-jc">
                <i class="iconfont icon-bi"></i>
              </div>
              <input ref="excel-upload-input" class="excel-upload-input" type="file" accept=".png,.jpg" style="display:none" @change="handleUpAvatar">
            </div>
            <div class="form-b">
              <div class="item flex-ac flex flex-jsb" @click="$store.commit('setPersonalOpen','name')">
                <div class="left">昵称</div>
                <div class="right">
                  <span>{{ userInfo.name || '未设置' }}</span>
                  <i class="el-icon-arrow-right"></i>
                </div>
              </div>
              <div class="item flex-ac flex flex-jsb">
                <div class="left">手机号</div>
                <div class="right">
                  <span>{{ userInfo.phone || '未设置' }}</span>
                  <i class="el-icon-arrow-right"></i>
                </div>
              </div>
              <div class="item flex-ac flex flex-jsb" @click="$store.commit('setPersonalOpen','password')">
                <div class="left">登录密码</div>
                <div class="right">
                  <span>去更换</span>
                  <i class="el-icon-arrow-right"></i>
                </div>
              </div>
              <div class="item flex-ac flex flex-jsb" @click="$store.commit('setPersonalOpen','tradeUrl')">
                <div class="left">steam取回链接</div>
                <div class="right">
                  <span>去设置</span>
                  <i class="el-icon-arrow-right"></i>
                </div>
              </div>
              <div class="item flex-ac flex flex-jsb">
                <div class="left">实名认证</div>
                <div class="right" v-if="$store.state.userInfo && $store.state.userInfo.sure_name == ''" @click="$store.commit('setPersonalOpen', 'idCard')">
                  <span>未认证</span>
                  <i class="el-icon-arrow-right"></i>
                </div>
                <div class="right" v-else>
                  <span>已认证</span>
                  <i class="el-icon-check"></i>
                </div>
              </div>
              <div class="item flex-ac flex flex-jsb" @click="handleBind">
                <div class="left">邀请码</div>
                <div class="right">
                  <span>{{ userInfo.superior_code?'已绑定':'未绑定' }}</span>
                  <i class="el-icon-arrow-right"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="personal-right">
          <div class="mobile-btn">
            <div class="btns flex flex-ac">
              <div class="btn btn-warning flex flex-jc flex-ac" @click="$refs['RulePopup'].toggle('Member')">
                <i class="iconfont icon-gz"></i>
                <span>查看会员规则</span>
              </div>
              <div class="btn flex flex-jc flex-ac" @click="$store.commit('setPersonalOpen','tradeUrl')">
                <i class="iconfont icon-jydz"></i>
                <span>交易地址</span>
              </div>
            </div>
          </div>
          <div class="new-csgo-table flex flex-ac flex-jsb">
            <div class="flex">
              <div class="table-item" :class="{'table-active':activeName=='dota'}" @click="handleClick('dota')">饰品</div>
              <div class="table-item" :class="{'table-active':activeName=='bill'}" @click="handleClick('bill')">明细</div>
              <div class="table-item" v-if="$store.state.userInfo && $store.state.userInfo.invite_open == 1" :class="{'table-active':activeName=='spread'}" @click="handleClick('spread')">收益</div>
            </div>
            <div class="btns pc-btn flex flex-ac">
              <div class="btn btn-warning flex flex-jc flex-ac" @click="$refs['RulePopup'].toggle('Member')">
                <i class="iconfont icon-gz"></i>
                <span>查看会员规则</span>
              </div>
              <div class="btn flex flex-jc flex-ac" @click="$store.commit('setPersonalOpen','tradeUrl')">
                <i class="iconfont icon-jydz"></i>
                <span>交易地址</span>
              </div>
            </div>
          </div>
          <div>
            <Dota v-if="activeName=='dota'" />
            <Spread v-if="activeName=='spread'" />
            <Bill v-if="activeName=='bill'" />
          </div>
        </div>
      </div>
    </div>
    <myhomebot></myhomebot>
    <RulePopup ref="RulePopup" />
    <div class="commonBg"></div>
  </div>
</template>

<script>
import deepClone from "@/assets/js/deepClone.js";
import myhomebot from "@/components/my_homebot.vue";
import mySlide from "@/g-components/my_slide.vue";
import RulePopup from "@/components/rule-popup.vue"
import Dota from "@/views/me/dota.vue"
import Spread from "@/views/me/spread.vue"
import Bill from "@/views/me/bill.vue"
import { mapGetters } from 'vuex'

export default {
  components: { myhomebot, mySlide, RulePopup, Dota, Spread, Bill },
  data() {
    return {
      myLevel: {
        title: '',
        img: '',
        next: {
          has: 0,
          img: '',
          progress: 0,
          target: '',
          title: '',
        }
      },
      activeName: 'dota',
      // info 表示展示的是背包，明细等  set 表示的是个人详情编辑
      setting: 'info'
    };
  },
  computed: {
    ...mapGetters([
      'userInfo'
    ])
  },
  created() {
    this.getData()
  },
  mounted() { },
  methods: {
    // 获取上级的名称
    getData() {
      this.$doGet("/api/member.Member/myLevel").then((res) => {
        this.myLevel = res.data
      }).catch(() => { })
    },
    handleBind() {
      if (this.userInfo.superior_code == '') {
        this.$store.commit('setPersonalOpen', 'bind')
      }
    },
    goCharge() {
      this.$store.commit("setPaymentOpen", true)
    },
    // tab 切换
    handleClick(e) {
      if (e == this.activeName) {
        return false
      }
      this.activeName = e
    },
    //退出登录
    async nextLogin() {
      await this.$store.dispatch('logout')
      this.drawer = false
      this.$router.push({
        path: `/Index`,
      })
    },
    handleChangeSetting() {
      this.setting = this.setting == 'info' ? 'set' : 'info'
    },
    // 编辑头像
    handleUpAvatar(e) {
      let formData = new FormData();
      formData.append('file', e.target.files[0])
      this.$doPost("/api/member.Member/avatar", formData).then((res) => {
        this.$store.state.img = res.data.file_url
        let form = deepClone(this.$store.state.userInfo)
        form.img = res.data.file_url
        this.$store.state.userInfo = form
        localStorage.setItem('userInfo', JSON.stringify(form))
      }).catch(() => { })
    }
  }
}
</script>

<style lang="less" scoped>
.personal {
  .personal-content {
    align-items: stretch;
    min-height: 100vh;
    padding: 30px 0;
    .personal-info {
      margin-right: 15px;
      background: #1b1c20;
      border-radius: 8px;
      color: #fff;
      position: relative;
      padding: 20px;
      box-sizing: border-box;
      width: 400px;
      .seting-box {
        position: absolute;
        top: 0px;
        right: 0px;
        padding: 24px;
        font-size: 14px;
        cursor: pointer;
        i {
          margin-right: 8px;
        }
      }
      .avatar-img {
        height: 100px;
        width: 100px;
      }
      .edit {
        font-size: 24px;
        font-weight: bold;
        margin-top: 24px;
        cursor: pointer;
        .e {
          font-size: 16px;
          font-weight: 100;
        }
      }
      .level {
        margin: 18px 0;
        font-size: 16px;
        .level-item {
          padding-right: 10px;
          .span-1 {
            margin-right: 12px;
          }
          &.level-money {
            color: #ffc400;
          }
          &.level-masonry {
            color: #00f7ff;
          }
          &:last-child {
            padding: 0;
          }
        }
      }
      .progress-box {
        .level-item {
          margin-right: 10px;
        }
        .t {
          font-weight: bold;
          // margin-bottom: 12px;
        }
        ::v-deep .el-progress-bar__outer {
          background: linear-gradient(180deg, #73250b 0%, #a95017 100%);
          border: 2px solid #73250b;
        }
        ::v-deep .el-progress-bar__inner {
          background: linear-gradient(0deg, #ffc400 0%, #fceda7 100%);
        }
      }
      .btn-w-r-bg {
        margin-top: 36px;
      }
    }
    .personal-right {
      width: calc(100% - 415px);
      background: #1b1c20;
      border-radius: 8px;
      .new-csgo-table {
        padding-right: 15px;
      }
      .btns {
        .btn {
          padding: 0 12px;
          line-height: 30px;
          background: #346162;
          border-radius: 4px;
          border: 1px solid #00f7ff;
          font-size: 14px;
          color: #00f7ff;
          cursor: pointer;
          i {
            margin-right: 8px;
          }
          &.btn-warning {
            background: #554b29;
            border: 1px solid #ffc400;
            color: #ffc400;
            margin-right: 16px;
          }
        }
      }
    }
    .mobile-btn {
      padding: 15px 0px 0 15px;
      display: none;
    }
  }
}
.peroson-form {
  .head-img {
    width: 100px;
    height: 100px;
    margin: 0 auto;
    position: relative;
    cursor: pointer;
    .icon-edit {
      width: 24px;
      height: 24px;
      background: #ffc400;
      border-radius: 50%;
      color: #2b2e3c;
      position: absolute;
      bottom: 0;
      right: 0;
    }
  }
  .form-b {
    background: #424242;
    border-radius: 8px;
    margin-top: 36px;
    .item {
      border-bottom: 1px solid #5a5656;
      height: 60px;
      padding: 0 15px;
      cursor: pointer;
      &:last-child {
        border-bottom: 0;
      }
      .right {
        line-height: 21px;
        i {
          margin-left: 5px;
        }
      }
    }
  }
}
</style>
